import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <p>&copy; 2026 Open KI IoT Hub</p>
        </div>
        <div className="footer-right">
          <span className="footer-link footer-link--disabled">Dokumentation</span>
          <span className="footer-divider"></span>
          <span className="footer-link footer-link--disabled">Impressum</span>
          <span className="footer-divider"></span>
          <span className="footer-link footer-link--disabled">Datenschutz</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
